import React from 'react';

import {PayOverTimeLocations, PayLaterMethods, PaypalIframeTypes} from 'constants/payOverTime';

import {KlarnaButton} from './klarna/klarnaButton';
import {PaypalButton} from './payPal/payPalButton';

/**
 * render pay over time method button by payLaterMethod type
 */
export const ButtonChooser = ({
    amount = 0,
    location,
    payLaterMethod,
}: {
    payLaterMethod: PayLaterMethods;
    amount?: number;
    location: PayOverTimeLocations;
}): React.JSX.Element | null => {
    const mappings: Record<PayLaterMethods, React.JSX.Element> = {
        [PayLaterMethods.KLARNA_PAY_LATER]: <KlarnaButton amount={amount} location={location} />,
        [PayLaterMethods.PAY_LATER_LONG_TERM]: (
            <PaypalButton
                amount={amount}
                location={location}
                type={PaypalIframeTypes.PAY_LATER_LONG_TERM}
            />
        ),
        [PayLaterMethods.PAY_LATER_SHORT_TERM]: (
            <PaypalButton
                amount={amount}
                location={location}
                type={PaypalIframeTypes.PAY_LATER_SHORT_TERM}
            />
        ),
        [PayLaterMethods.PAYPAL_CREDIT_NO_INTEREST]: (
            <PaypalButton
                amount={amount}
                location={location}
                type={PaypalIframeTypes.PAYPAL_CREDIT_NO_INTEREST}
            />
        ),
    };
    return mappings[payLaterMethod] || null;
};
